// AUTO-GENERATED by curriculum-gen/src/gen_peninsula_district.py — do not edit by hand.
// Backs the public /curriculum/district/peninsula landing page with the real,
// CKLA-aligned lessons (same templates live in the catalog). Clean + self-contained.
export interface CurriculumLesson {
  program: string; grade: string; theme: string; title: string; prompt: string;
  plan: string; purpose: string; importantWords: string[]; standards: string[];
}
export interface CurriculumDistrict {
  slug: string; name: string; state: string; location: string; framework: string; gradeRange: string;
  socialProof?: string;
  lessonCount: number; programs: string[]; lessons: CurriculumLesson[];
}

export const PENINSULA_DISTRICT: CurriculumDistrict = {
  "slug": "peninsula",
  "name": "Peninsula School District",
  "state": "WA",
  "location": "Gig Harbor & the Key Peninsula · Pierce County, Washington, USA",
  "framework": "Washington State ELA Learning Standards (Common Core)",
  "gradeRange": "K–5",
  "lessonCount": 64,
  "programs": [
    "Amplify CKLA"
  ],
  "lessons": [
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 1 — Nursery Rhymes and Fables",
      "title": "My Favorite Nursery Rhyme",
      "prompt": "Nursery rhymes are fun little poems we say and sing.\n\nDraw and write about your favorite nursery rhyme. Tell your reader what happens in it.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "rhyme",
        "poem",
        "sing",
        "story",
        "favorite",
        "fun",
        "words",
        "character"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 10 — Colonial Towns and Townspeople",
      "title": "Life in a Colonial Town",
      "prompt": "Long ago, people in colonial towns had many different jobs to help each other.\n\nDraw and write to tell your reader about a worker in a colonial town and the job they did.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "town",
        "job",
        "worker",
        "long ago",
        "blacksmith",
        "shop",
        "help",
        "community"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 11 — Taking Care of the Earth",
      "title": "Taking Care of the Earth",
      "prompt": "We can all help take care of our planet, the Earth.\n\nDraw and write to tell your reader one way you can take care of the Earth.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Earth",
        "care",
        "recycle",
        "reuse",
        "clean",
        "trash",
        "help",
        "planet"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 12 — Presidents and American Symbols",
      "title": "Our American Symbols",
      "prompt": "American symbols, like the flag and the bald eagle, stand for our country.\n\nDraw and write to tell your reader about an American symbol and what it means.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "symbol",
        "flag",
        "eagle",
        "country",
        "America",
        "president",
        "stars",
        "proud"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 2 — The Five Senses",
      "title": "My Five Senses",
      "prompt": "We use our five senses to learn about the world: seeing, hearing, smelling, tasting, and touching.\n\nPick one of your senses. Draw and write to tell what you can do with it.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "senses",
        "see",
        "hear",
        "smell",
        "taste",
        "touch",
        "eyes",
        "ears"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 3 — Stories",
      "title": "A Story I Love",
      "prompt": "Stories take us on adventures and teach us about the world.\n\nChoose a story you love. Draw and write to tell your reader what happens in it.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "story",
        "character",
        "beginning",
        "end",
        "adventure",
        "favorite",
        "happens",
        "love"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 4 — Plants",
      "title": "How a Plant Grows",
      "prompt": "Plants need sunlight, water, and soil to grow.\n\nDraw and write to tell your reader how a plant grows, or about a plant you know.",
      "plan": "sequence",
      "purpose": "Inform & Explain",
      "importantWords": [
        "plant",
        "seed",
        "grow",
        "soil",
        "water",
        "sun",
        "root",
        "leaf"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 5 — Farms",
      "title": "On the Farm",
      "prompt": "Farms give us food and are home to many animals.\n\nDraw and write to tell your reader about a farm — an animal, a plant, or a job a farmer does.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "farm",
        "farmer",
        "animal",
        "crop",
        "cow",
        "tractor",
        "barn",
        "food"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 6 — Native Americans",
      "title": "Native Americans Long Ago",
      "prompt": "Native Americans were the first people to live on this land, long ago.\n\nDraw and write to tell your reader one thing you learned about how Native Americans lived.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Native American",
        "land",
        "long ago",
        "home",
        "food",
        "hunt",
        "people",
        "first"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 7 — Kings and Queens",
      "title": "Kings and Queens",
      "prompt": "Long ago, kings and queens ruled over lands and lived in castles.\n\nDraw and write to tell your reader about a king or queen — where they lived or what they did.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "king",
        "queen",
        "castle",
        "crown",
        "rule",
        "kingdom",
        "throne",
        "royal"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 8 — Seasons and Weather",
      "title": "My Favorite Season",
      "prompt": "The four seasons are winter, spring, summer, and fall. Each one has its own weather.\n\nDraw and write to tell your reader about your favorite season and what the weather is like.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "season",
        "winter",
        "spring",
        "summer",
        "fall",
        "weather",
        "sunny",
        "snow"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "K",
      "theme": "Kindergarten Domain 9 — Columbus and the Pilgrims",
      "title": "A Long Journey Across the Sea",
      "prompt": "Long ago, people sailed across the ocean on big ships to find new lands.\n\nDraw and write to tell your reader about a journey across the sea — the ship, the ocean, or the people.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "ship",
        "ocean",
        "sail",
        "journey",
        "land",
        "explore",
        "sea",
        "long ago"
      ],
      "standards": [
        "W.K.2",
        "W.K.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 1 — Fables and Stories",
      "title": "What a Fable Teaches Us",
      "prompt": "A fable is a short story that teaches a lesson.\n\nChoose a fable you read. Write to tell your reader what happens in the story and what lesson it teaches.\n\nUse details from the fable so your reader understands.",
      "plan": "retell-the-narrative",
      "purpose": "Inform & Explain",
      "importantWords": [
        "fable",
        "lesson",
        "character",
        "story",
        "moral",
        "wise",
        "foolish",
        "teach",
        "clever",
        "kind"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 10 — A New Nation: American Independence",
      "title": "How America Began",
      "prompt": "Long ago, the United States became its own new country.\n\nWrite to tell your reader something you learned about how America began — a person, an event, or an important idea.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "America",
        "country",
        "independence",
        "freedom",
        "colony",
        "flag",
        "leader",
        "war",
        "nation",
        "history"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 11 — Frontier Explorers",
      "title": "Explorers of the Frontier",
      "prompt": "Brave explorers traveled west into wild and unknown lands.\n\nWrite to tell your reader about the explorers of the American frontier — where they went and what their journey was like.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "explorer",
        "frontier",
        "west",
        "journey",
        "trail",
        "wilderness",
        "river",
        "map",
        "discover",
        "brave"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 2 — The Human Body",
      "title": "How My Body Works",
      "prompt": "Your body has many parts that work together to keep you healthy.\n\nChoose one part of the body you learned about — like your heart, bones, or muscles. Write to teach your reader what it does.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "body",
        "heart",
        "bones",
        "muscles",
        "blood",
        "brain",
        "healthy",
        "system",
        "breathe",
        "grow"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 3 — Different Lands, Similar Stories",
      "title": "A Story From Around the World",
      "prompt": "People all over the world tell stories, and many of them are alike in surprising ways.\n\nChoose a story you read from another land. Write to tell your reader what happens in it and what makes it special.\n\nUse details from the story.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "story",
        "country",
        "culture",
        "folktale",
        "land",
        "character",
        "tradition",
        "journey",
        "similar",
        "different"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 4 — Early World Civilizations",
      "title": "Life Along the River Long Ago",
      "prompt": "Long, long ago, people built some of the first cities next to great rivers like the Nile.\n\nWrite to tell your reader about life in early Mesopotamia or ancient Egypt — how people lived, farmed, or built.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "river",
        "Egypt",
        "Mesopotamia",
        "ancient",
        "farm",
        "city",
        "pyramid",
        "writing",
        "civilization",
        "long ago"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 5 — Early American Civilizations",
      "title": "The Maya, Aztec, and Inca",
      "prompt": "Long ago, the Maya, Aztec, and Inca built great civilizations in the Americas.\n\nChoose one of these peoples. Write to tell your reader about them — where they lived and something amazing they did.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Maya",
        "Aztec",
        "Inca",
        "ancient",
        "temple",
        "city",
        "civilization",
        "mountain",
        "jungle",
        "build"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 6 — Astronomy",
      "title": "Our Place in Space",
      "prompt": "Earth is just one part of our amazing solar system.\n\nChoose something you learned about space — the sun, the moon, a planet, or the stars. Write to teach your reader about it.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "space",
        "sun",
        "moon",
        "planet",
        "star",
        "Earth",
        "orbit",
        "solar system",
        "astronaut",
        "telescope"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 7 — The History of the Earth",
      "title": "What's Inside the Earth",
      "prompt": "Our planet Earth is made of layers, and it changes over a very long time.\n\nWrite to teach your reader something you learned about the Earth — its layers, its rocks, or how it changes.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Earth",
        "layer",
        "rock",
        "soil",
        "volcano",
        "core",
        "crust",
        "mountain",
        "fossil",
        "change"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 8 — Animals and Habitats",
      "title": "An Animal and Its Home",
      "prompt": "Every animal lives in a habitat that gives it what it needs to survive.\n\nChoose an animal you studied. Write to teach your reader about it — where it lives and how its home helps it.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "animal",
        "habitat",
        "home",
        "survive",
        "food",
        "shelter",
        "ocean",
        "forest",
        "desert",
        "adapt"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "1st",
      "theme": "Grade 1 Domain 9 — Fairy Tales",
      "title": "My Favorite Fairy Tale",
      "prompt": "Fairy tales are full of magic, heroes, and adventures.\n\nChoose your favorite fairy tale. Write to tell your reader what happens in it and why you like it.\n\nUse details from the story.",
      "plan": "retell-the-narrative",
      "purpose": "Inform & Explain",
      "importantWords": [
        "fairy tale",
        "magic",
        "hero",
        "adventure",
        "castle",
        "character",
        "kingdom",
        "brave",
        "wish",
        "ending"
      ],
      "standards": [
        "W.1.2",
        "W.1.8"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Domain 11 — Immigration",
      "title": "Coming to America",
      "prompt": "Long ago and still today, people move to America from all over the world to build new lives.\n\nWrite to explain why people immigrate to America — what they hope for, what the journey is like, and what they find when they arrive.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "immigrant",
        "immigrate",
        "journey",
        "Ellis Island",
        "homeland",
        "freedom",
        "opportunity",
        "citizen",
        "arrive",
        "new"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Domain 12 — Fighting for a Cause",
      "title": "Fighting for What's Right",
      "prompt": "Throughout history, brave people have stood up and fought for what they believed was right.\n\nChoose a person or group you studied who fought for a cause. Write to explain what they were fighting for and how they tried to make a change.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Inform & Explain",
      "importantWords": [
        "cause",
        "fight",
        "rights",
        "justice",
        "change",
        "leader",
        "protest",
        "equality",
        "brave",
        "believe"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L1: Insects Everywhere!",
      "title": "Insects Are Everywhere",
      "prompt": "Insects are the largest group of animals on Earth — they live almost everywhere!\n\nWrite to teach your reader about insects — where they live, how many kinds there are, and why they are so successful.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "insect",
        "everywhere",
        "species",
        "habitat",
        "common",
        "Earth",
        "tiny",
        "survive",
        "group",
        "variety"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L2: What Makes an Insect an Insect?",
      "title": "What Makes an Insect an Insect?",
      "prompt": "Not every little crawling creature is an insect. Insects have special features that set them apart.\n\nWrite to explain what makes an insect an insect — the body parts and features every insect has.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "insect",
        "head",
        "thorax",
        "abdomen",
        "antennae",
        "six legs",
        "exoskeleton",
        "wings",
        "body",
        "feature"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L3: Life Cycles of Insects",
      "title": "The Life Cycle of an Insect",
      "prompt": "Insects change as they grow, sometimes in amazing ways called metamorphosis.\n\nWrite to explain the life cycle of an insect — the stages it goes through from the beginning of its life to adulthood.\n\nUse facts and details from your reading so your reader understands the order.",
      "plan": "sequence",
      "purpose": "Inform & Explain",
      "importantWords": [
        "life cycle",
        "metamorphosis",
        "egg",
        "larva",
        "pupa",
        "adult",
        "stage",
        "grow",
        "change",
        "transform"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L4: Social Insects: Bees and Wasps",
      "title": "Bees and Wasps Live Together",
      "prompt": "Some insects, like bees and wasps, live and work together in large groups.\n\nWrite to explain how bees or wasps live together — their roles, their home, and how they help one another.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "bee",
        "wasp",
        "social",
        "colony",
        "hive",
        "queen",
        "worker",
        "nest",
        "honey",
        "together"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L5: Social Insects: Ants and Termites",
      "title": "Ants and Termites: Master Builders",
      "prompt": "Ants and termites are social insects that build amazing homes and work as a team.\n\nWrite to explain how ants or termites live and work together to build their homes and find food.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "ant",
        "termite",
        "colony",
        "tunnel",
        "mound",
        "worker",
        "queen",
        "cooperate",
        "build",
        "nest"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L6: Insects that Glow and Sing",
      "title": "Insects That Glow and Sing",
      "prompt": "Some insects light up the night, and others fill the air with sound.\n\nWrite to explain how some insects glow or make sounds — like fireflies and crickets — and why they do it.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "firefly",
        "glow",
        "cricket",
        "chirp",
        "light",
        "sound",
        "signal",
        "night",
        "mate",
        "wings"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L7: Armored Tanks of the Insect World",
      "title": "The Armored Insects",
      "prompt": "Some insects, like beetles, have hard, armored bodies that protect them like tiny tanks.\n\nWrite to describe these armored insects — how their tough bodies help them survive.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "beetle",
        "armor",
        "shell",
        "hard",
        "exoskeleton",
        "protect",
        "tough",
        "wings",
        "tank",
        "survive"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Insects · L8: Friend or Foe?",
      "title": "Insects: Friend or Foe?",
      "prompt": "Some insects help people, and some cause problems. Are insects friends or foes?\n\nWrite to explain ways insects can be helpful AND ways they can be harmful to people and plants.\n\nUse facts and details from your reading to support both sides.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "friend",
        "foe",
        "helpful",
        "harmful",
        "pollinate",
        "pest",
        "crop",
        "protect",
        "damage",
        "useful"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 1 — Fairy Tales and Tall Tales",
      "title": "A Tall Tale Hero",
      "prompt": "Tall tales are stories about larger-than-life heroes who do impossible things — like Paul Bunyan or Pecos Bill.\n\nChoose a fairy tale or tall tale you read. Write to tell your reader what happens in it and what makes the hero or story special.\n\nUse details from the story so your reader can picture it.",
      "plan": "retell-the-narrative",
      "purpose": "Inform & Explain",
      "importantWords": [
        "tall tale",
        "fairy tale",
        "hero",
        "legend",
        "exaggerate",
        "character",
        "adventure",
        "impossible",
        "brave",
        "story"
      ],
      "standards": [
        "W.2.2",
        "W.2.3"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 10 — The Human Body: Building Blocks and Nutrition",
      "title": "Taking Care of Your Body",
      "prompt": "Your body needs good food to grow strong and healthy.\n\nWrite to teach your reader how to take care of their body — what foods help, and why eating well matters.\n\nUse facts and details from your reading.",
      "plan": "sequence",
      "purpose": "Inform & Explain",
      "importantWords": [
        "body",
        "nutrition",
        "food",
        "healthy",
        "energy",
        "vitamin",
        "muscle",
        "cell",
        "grow",
        "exercise"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 2 — Early Asian Civilizations",
      "title": "A Story From Early Asia",
      "prompt": "You learned about two great early civilizations in Asia — India and China — and the mighty rivers that helped them grow.\n\nChoose one thing you learned about life in early India or early China. Write to tell your reader about it.\n\nUse facts from your reading and details that help your reader picture it.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Asia",
        "India",
        "China",
        "river",
        "civilization",
        "ancient",
        "emperor",
        "silk",
        "trade",
        "temple"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 3 — Ancient Greek Civilization",
      "title": "Life in Ancient Greece",
      "prompt": "Long ago, the ancient Greeks built a great civilization.\n\nChoose one thing about the ancient Greeks — their cities, their gods, the Olympics, or how they lived. Write to teach your reader about it.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Greece",
        "ancient",
        "Olympics",
        "city-state",
        "temple",
        "philosopher",
        "marketplace",
        "citizen",
        "column",
        "democracy"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 4 — Greek Myths",
      "title": "A Greek Myth Worth Telling",
      "prompt": "The ancient Greeks told myths about powerful gods, brave heroes, and amazing creatures.\n\nChoose one Greek myth you read. Write to tell your reader what happens in it and what the myth was meant to explain or teach.\n\nUse details from your reading to support your retelling.",
      "plan": "retell-the-narrative",
      "purpose": "Inform & Explain",
      "importantWords": [
        "myth",
        "god",
        "goddess",
        "hero",
        "Mount Olympus",
        "monster",
        "Zeus",
        "ancient",
        "legend",
        "lesson"
      ],
      "standards": [
        "W.2.2",
        "W.2.3"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 5 — The War of 1812",
      "title": "An Event From the War of 1812",
      "prompt": "The War of 1812 was an important time in American history.\n\nChoose one event you learned about — like the burning of Washington or the Battle of New Orleans. Write to explain what happened.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "war",
        "battle",
        "soldier",
        "fort",
        "flag",
        "anthem",
        "capital",
        "defend",
        "victory",
        "history"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 6 — Cycles in Nature",
      "title": "A Cycle in Nature",
      "prompt": "Nature is full of cycles that happen again and again.\n\nChoose one cycle you studied — like the water cycle or the seasons. Write to explain how it works.\n\nUse facts and details from your reading.",
      "plan": "sequence",
      "purpose": "Inform & Explain",
      "importantWords": [
        "cycle",
        "season",
        "water",
        "evaporate",
        "rain",
        "nature",
        "change",
        "repeat",
        "weather",
        "growth"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 7 — Westward Expansion",
      "title": "The Journey West",
      "prompt": "Long ago, many Americans traveled west to start new lives.\n\nWrite to tell your reader what the journey west was like — how people traveled, what was hard, and why they went.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "west",
        "pioneer",
        "wagon",
        "trail",
        "frontier",
        "settler",
        "journey",
        "prairie",
        "territory",
        "travel"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 8 — Insects",
      "title": "All About an Insect",
      "prompt": "Insects are the largest group of animals on Earth!\n\nChoose one insect you studied. Write to teach your reader about it — what it looks like, how it lives, and what makes it special.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "insect",
        "antennae",
        "wings",
        "beetle",
        "larva",
        "metamorphosis",
        "colony",
        "habitat",
        "pollinate",
        "exoskeleton"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "2nd",
      "theme": "Grade 2 Unit 9 — The US Civil War",
      "title": "Learning About the Civil War",
      "prompt": "The Civil War was a hard time when our country was divided.\n\nChoose one thing you learned — a leader, an event, or a reason for the war. Write to explain it.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Civil War",
        "North",
        "South",
        "slavery",
        "Union",
        "soldier",
        "freedom",
        "Lincoln",
        "battle",
        "divided"
      ],
      "standards": [
        "W.2.2"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 1 — Classic Tales: The Wind in the Willows",
      "title": "My Favorite Character in the Story",
      "prompt": "In The Wind in the Willows, you met characters like Mole, Rat, and Toad.\n\nChoose your favorite character. Write to describe what they are like and why they are your favorite.\n\nUse details and examples from the story to support your ideas.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "character",
        "adventure",
        "friend",
        "river",
        "brave",
        "loyal",
        "clever",
        "journey",
        "home",
        "story"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 2 — Classification of Animals",
      "title": "What Makes an Animal Group Special",
      "prompt": "Scientists sort animals into groups based on what they have in common.\n\nChoose one group of animals you studied — mammals, birds, fish, reptiles, or amphibians. Write an informative piece that explains what makes that group special: how they move, how they breathe, how they have babies, and how they survive.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "mammal",
        "reptile",
        "amphibian",
        "vertebrate",
        "classify",
        "species",
        "habitat",
        "characteristic",
        "scales",
        "gills"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 3 — The Human Body",
      "title": "The Amazing Machine Inside You",
      "prompt": "Your body is an amazing machine, with many parts that work together to keep you alive.\n\nChoose one body system you studied — like the digestive, skeletal, or muscular system. Write an informative piece that explains what it does and how it helps keep you healthy.\n\nUse facts and details from your reading so your reader understands how it works.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "system",
        "organ",
        "muscle",
        "skeleton",
        "digestion",
        "nerve",
        "heart",
        "lungs",
        "healthy",
        "function"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 4 — The Ancient Roman Civilization",
      "title": "Picture Life in Ancient Rome",
      "prompt": "Ancient Rome grew from a small city into one of the greatest empires in history.\n\nChoose one part of Roman life that interests you — their government, their army, their buildings, or daily life. Write an informative piece that explains it.\n\nUse facts and details from your reading so your reader can picture what ancient Rome was really like.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Rome",
        "empire",
        "emperor",
        "citizen",
        "gladiator",
        "aqueduct",
        "Senate",
        "Latin",
        "conquer",
        "ancient"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 5 — Light and Sound",
      "title": "How Light and Sound Travel",
      "prompt": "Light and sound are all around us — but how do they actually work?\n\nChoose one, light or sound, and write an informative piece that explains how it travels and how we see it or hear it.\n\nUse facts and details from your reading to make your explanation clear.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "light",
        "sound",
        "wave",
        "vibration",
        "reflect",
        "energy",
        "pitch",
        "volume",
        "travel",
        "sense"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 6 — The Viking Age",
      "title": "Life in the Viking Age",
      "prompt": "The Vikings were explorers, traders, and warriors from northern Europe.\n\nChoose one part of Viking life — their ships, their voyages, their homes, or their beliefs — and write an informative piece that explains it.\n\nUse facts and details from your reading so your reader understands what life was like in the Viking Age.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Viking",
        "Norse",
        "Scandinavia",
        "longship",
        "explorer",
        "raid",
        "trade",
        "voyage",
        "warrior",
        "settlement"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 7 — Astronomy: Our Solar System and Beyond",
      "title": "Amazing Things in Space",
      "prompt": "Beyond our planet lies a huge universe full of stars, planets, and galaxies.\n\nChoose one thing you studied in astronomy — a planet, the moon, the sun, or the stars — and write an informative piece that explains what it is and what makes it so amazing.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "planet",
        "solar system",
        "galaxy",
        "star",
        "orbit",
        "gravity",
        "telescope",
        "universe",
        "moon",
        "astronomer"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "3rd",
      "theme": "Grade 3 Unit 8 — Native America",
      "title": "How Native Peoples Lived With the Land",
      "prompt": "Long before Europeans arrived, Native American nations lived all across the land, each with its own way of life.\n\nChoose one Native American people or region you studied. Write an informative piece that describes how they lived — their homes, their food, and their traditions — and how they used the land around them.\n\nUse facts from your reading so your reader understands their way of life.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "nation",
        "tribe",
        "region",
        "tradition",
        "culture",
        "resources",
        "dwelling",
        "hunt",
        "ceremony",
        "ancestor"
      ],
      "standards": [
        "W.3.2",
        "W.3.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 2 — The Middle Ages",
      "title": "Life in the Middle Ages",
      "prompt": "You've learned how people lived in the Middle Ages — in castles, villages, and monasteries, under kings, knights, and lords.\n\nChoose one part of medieval life that interests you most: how a castle was defended, what a knight's life was like, or how a village worked. Write an informative piece that explains it clearly.\n\nUse facts and details from your reading so your reader can really picture life in the Middle Ages.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "medieval",
        "castle",
        "knight",
        "lord",
        "peasant",
        "monastery",
        "feudal",
        "manor",
        "noble",
        "fortress"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 4 — Islamic Empires in the Middle Ages",
      "title": "A Gift From the Islamic World",
      "prompt": "During the Middle Ages, Islamic empires became great centers of learning, trade, and invention.\n\nChoose one achievement of the Islamic world — in math, medicine, science, or art — and write an informative piece that explains what it was and why it mattered to the world.\n\nUse facts from your reading to help your reader understand why this achievement was so important.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "empire",
        "scholar",
        "algebra",
        "medicine",
        "astronomy",
        "trade",
        "mosque",
        "caliph",
        "invention",
        "manuscript"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 5 — Eureka! Student Inventor",
      "title": "The Invention the World Needs",
      "prompt": "Inventors change the world by solving real problems.\n\nImagine you are an inventor. Think of a problem people face every day, then describe an invention you would create to solve it. Write an informative piece that explains the problem, your invention, and exactly how it would help.\n\nUse clear details so your reader understands how your invention works.",
      "plan": "problem-solution",
      "purpose": "Inform & Explain",
      "importantWords": [
        "invention",
        "inventor",
        "design",
        "solution",
        "problem",
        "machine",
        "improve",
        "create",
        "build",
        "useful"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 6 — Geology",
      "title": "How the Earth Is Built",
      "prompt": "You've studied how Earth is built — its layers, its rocks and minerals, and the slow forces that shape mountains and valleys.\n\nPick one geological idea you find fascinating: how mountains form, how rocks change over time, or what lies beneath our feet. Write an informative piece that explains how it works.\n\nUse facts and details from your reading so your explanation is clear.",
      "plan": "sequence",
      "purpose": "Inform & Explain",
      "importantWords": [
        "geology",
        "mineral",
        "sediment",
        "erosion",
        "magma",
        "crust",
        "fossil",
        "plate",
        "volcano",
        "layer"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 7 — The American Revolution",
      "title": "A Turning Point in the Revolution",
      "prompt": "The American Revolution changed history.\n\nChoose one cause, event, or person from the Revolution — a key battle, the Declaration of Independence, or a leader like George Washington — and write an informative piece that explains what happened and why it mattered.\n\nUse facts from your reading to support your explanation.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "revolution",
        "colony",
        "independence",
        "liberty",
        "Patriot",
        "taxation",
        "Declaration",
        "militia",
        "Parliament",
        "freedom"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "4th",
      "theme": "Grade 4 Unit 8 — Treasure Island",
      "title": "The Most Exciting Part of the Story",
      "prompt": "In Treasure Island, young Jim Hawkins goes on a dangerous adventure.\n\nWrite to retell the most exciting part of the story — what happened, who was there, and why it mattered.\n\nUse details from the book so your reader can picture it.",
      "plan": "retell-the-narrative",
      "purpose": "Inform & Explain",
      "importantWords": [
        "treasure",
        "island",
        "pirate",
        "map",
        "adventure",
        "ship",
        "captain",
        "danger",
        "voyage",
        "gold"
      ],
      "standards": [
        "W.4.2",
        "W.4.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 2 — Early American Civilizations",
      "title": "Two Great Civilizations of the Americas",
      "prompt": "You've studied the Maya, Aztec, and Inca — civilizations that built cities and empires long before Europeans reached the Americas.\n\nChoose two of them. Write an informative piece that explains how they were alike and how they were different — their cities, how they were ruled, and what they built or invented.\n\nUse linking words like similarly, however, and in contrast, and include specific facts from your reading.",
      "plan": "compare-contrast",
      "purpose": "Inform & Explain",
      "importantWords": [
        "civilization",
        "empire",
        "Maya",
        "Aztec",
        "Inca",
        "temple",
        "emperor",
        "city-state",
        "calendar",
        "innovation"
      ],
      "standards": [
        "W.5.2",
        "W.5.4",
        "W.5.9"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 4 — House on Mango Street",
      "title": "A Place That Matters to Me",
      "prompt": "In The House on Mango Street, Esperanza writes short pieces about her life and her neighborhood.\n\nWrite to describe a place that matters to you — what it looks like, what it sounds like, and why it's important to you.\n\nUse details that help your reader truly picture it.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "neighborhood",
        "home",
        "belong",
        "dream",
        "memory",
        "street",
        "family",
        "identity",
        "hope",
        "place"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 5 — Adventures of Don Quixote",
      "title": "What Don Quixote's Adventure Shows Us",
      "prompt": "In Don Quixote, an old man imagines himself a heroic knight and sets off on wild adventures.\n\nChoose one of Don Quixote's adventures. Write to explain what happened and what it shows about who he is.\n\nUse details from the story to support your explanation.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "knight",
        "adventure",
        "imagination",
        "hero",
        "quest",
        "honor",
        "brave",
        "foolish",
        "loyal",
        "dream"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 6 — The Renaissance",
      "title": "An Idea That Changed the World",
      "prompt": "The Renaissance was a time when art, science, and ideas exploded across Europe.\n\nChoose one person, invention, or idea from the Renaissance that fascinates you — maybe Leonardo da Vinci, the printing press, or a new way of seeing the world. Write an informative essay that explains what it was and why it mattered.\n\nUse facts and details from your reading to help your reader understand why it changed people's lives.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Renaissance",
        "artist",
        "invention",
        "scholar",
        "humanism",
        "printing press",
        "perspective",
        "patron",
        "discovery",
        "masterpiece"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 7 — The Reformation",
      "title": "How New Ideas Spread",
      "prompt": "The Reformation changed how millions of people lived and worshipped. One powerful force behind it was the printing press, which spread new ideas faster than ever before.\n\nWrite an informative piece that explains how the printing press helped new ideas spread during the Reformation, and why that mattered.\n\nUse facts and details from your reading to support your explanation.",
      "plan": "cause-effect",
      "purpose": "Inform & Explain",
      "importantWords": [
        "Reformation",
        "printing press",
        "reformer",
        "church",
        "pamphlet",
        "spread",
        "belief",
        "protest",
        "translate",
        "movement"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 8 — A Midsummer Night's Dream",
      "title": "Magic and Mix-Ups in the Forest",
      "prompt": "Shakespeare's A Midsummer Night's Dream is full of magic, mix-ups, and mischief.\n\nWrite to explain what happens to the characters in the forest and how everything gets sorted out in the end.\n\nUse details from the play to support your explanation.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "play",
        "magic",
        "fairy",
        "forest",
        "love",
        "mischief",
        "dream",
        "confusion",
        "Shakespeare",
        "character"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    },
    {
      "program": "Amplify CKLA",
      "grade": "5th",
      "theme": "Grade 5 Unit 9 — Native Americans",
      "title": "Living With the Land",
      "prompt": "Native American nations built rich cultures long before Europeans arrived, each one shaped by the land they lived on.\n\nChoose one Native American nation or region you studied. Write an informative piece that describes how the people lived — their homes, food, traditions, and how they used the resources around them.\n\nUse specific facts from your reading so your reader truly understands their way of life.",
      "plan": "description",
      "purpose": "Inform & Explain",
      "importantWords": [
        "nation",
        "tribe",
        "culture",
        "tradition",
        "region",
        "resources",
        "ancestor",
        "ceremony",
        "dwelling",
        "community"
      ],
      "standards": [
        "W.5.2",
        "W.5.4"
      ]
    }
  ]
};

export const DISTRICT_BY_SLUG: Record<string, CurriculumDistrict> = {
  peninsula: PENINSULA_DISTRICT,
};
